import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";

const FormattedInput = ({ tipo, value, onChange, label }) => {
  const [formattedValue, setFormattedValue] = useState("");

  useEffect(() => {
    if (tipo === "decimal" && value) {
      const decimalValue = (parseFloat(value) || 0)
        .toFixed(2)
        .replace(".", ",");
      setFormattedValue(decimalValue);
    } else if (tipo === "inteiro" && value) {
      setFormattedValue(value.toString());
    }
  }, [tipo, value]);

  const handleInputChange = (e) => {
    const input = e.target.value;

    if (tipo === "inteiro") {
      // Permitir apenas números inteiros não negativos
      const integerValue = input.replace(/\D/g, ""); // Remove caracteres não numéricos
      setFormattedValue(integerValue);
      onChange(integerValue); // Retorna o valor bruto
    } else if (tipo === "decimal") {
      // Máscara para valores decimais no formato "0,00"
      const rawValue = input.replace(/\D/g, ""); // Remove caracteres não numéricos
      const decimalValue = (parseInt(rawValue, 10) / 100).toFixed(2); // Divide por 100 para formatar
      const formattedDecimal = decimalValue.replace(".", ","); // Substitui o ponto por vírgula
      setFormattedValue(formattedDecimal);
      onChange(decimalValue); // Retorna o valor em formato numérico (ponto flutuante)
    }
  };

  return (
    <TextField
      label={label}
      value={formattedValue}
      onChange={handleInputChange}
      inputProps={{
        inputMode: "numeric", // Para suportar números no mobile
        pattern: "[0-9]*", // Permitir apenas números
      }}
      fullWidth
      margin="normal"
    />
  );
};

export default FormattedInput;
